
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1uunn", function(module, exports) {

$parcel$export(module.exports, "useProfileController", () => $90ef72367fab294b$export$68afc71177137005);

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");

var $8gGM0 = parcelRequire("8gGM0");
const $90ef72367fab294b$var$fetchProfileData = (0, $csnse.default)(async ()=>{
    const data = await (0, $8gGM0.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $90ef72367fab294b$export$3c814b55c7cbb1fb = (0, $gwFzn.createContext)(null);
const $90ef72367fab294b$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $90ef72367fab294b$export$68afc71177137005 = ()=>{
    const [profileData, setProfileData] = (0, $gwFzn.useState)($90ef72367fab294b$var$emptyProfileData);
    const profileContextData = (0, $gwFzn.useContext)($90ef72367fab294b$export$3c814b55c7cbb1fb);
    (0, $gwFzn.useEffect)(()=>{
        if (profileContextData) setProfileData(profileContextData);
        else $90ef72367fab294b$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($90ef72367fab294b$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData
    ]);
    return profileData;
};

});
parcelRegister("8gGM0", function(module, exports) {

$parcel$export(module.exports, "me", () => $2f3ab166c93f3263$export$3e32638432616b6);

var $aYN6Z = parcelRequire("aYN6Z");
const $2f3ab166c93f3263$export$3e32638432616b6 = async ()=>{
    const response = await (0, $aYN6Z.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};

});
parcelRegister("aYN6Z", function(module, exports) {

$parcel$export(module.exports, "performHttpFetch", () => $17e0e2057f17f262$export$a38d93aa782475f6);
//Shared code with conversation-assistant-instrumentation/src/common/utils/fetch.ts

var $i8byp = parcelRequire("i8byp");
//TODO have this extend RovoInstrumentedError once that PR is merged
class $17e0e2057f17f262$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $17e0e2057f17f262$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $17e0e2057f17f262$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        throw new (0, $i8byp.FetchError)(`performHttpFetch error whle fetching ${path}`, {
            cause: err
        });
    }
};
const $17e0e2057f17f262$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $17e0e2057f17f262$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status
    });
};

});
parcelRegister("i8byp", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $d3034141a03c41f7$export$26e841bcf1aeb894);
class $d3034141a03c41f7$export$26e841bcf1aeb894 extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
        this.name = 'FetchError';
        if (cause) this.cause = cause;
    }
}

});




parcelRegister("fQF1W", function(module, exports) {

$parcel$export(module.exports, "useAtlasURL", () => $2a6bb271c0fd2ecb$export$8a1abb7c176bd202);
$parcel$export(module.exports, "useCreateAgentAtlasURL", () => $2a6bb271c0fd2ecb$export$b61b99f9ac0264be);

var $gwFzn = parcelRequire("gwFzn");

var $827Ne = parcelRequire("827Ne");

var $dYtRL = parcelRequire("dYtRL");
const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $gwFzn.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};

});
parcelRegister("827Ne", function(module, exports) {

$parcel$export(module.exports, "getAtlasHost", () => $5ae4133df3384b49$export$5105758c0e772381);
$parcel$export(module.exports, "getAtlasURL", () => $5ae4133df3384b49$export$bfee0f88bf621ad3);

var $6FQwA = parcelRequire("6FQwA");
const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};

});

parcelRegister("dYtRL", function(module, exports) {

$parcel$export(module.exports, "useTenantDataController", () => $63d59501eb65c4db$export$b863fec6791eae25);

var $16lEl = parcelRequire("16lEl");
var $7pmZw = parcelRequire("7pmZw");

var $9eLw5 = parcelRequire("9eLw5");

var $hGGLc = parcelRequire("hGGLc");
const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    const experience = (0, $7pmZw.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};

});
parcelRegister("hGGLc", function(module, exports) {

$parcel$export(module.exports, "getCloudUrlFromId", () => $0fc4c72c92b990ea$export$d4ace54df9bd6bb1);

var $b62XF = parcelRequire("b62XF");
const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    const response = await (0, $b62XF.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};

});
parcelRegister("b62XF", function(module, exports) {

$parcel$export(module.exports, "performGqlFetch", () => $37e96b9c44d16228$export$f602b5befecb0b84);

var $i8byp = parcelRequire("i8byp");
const $37e96b9c44d16228$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : null;
};
const $37e96b9c44d16228$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            })
        });
        const json = await response.json();
        if (json?.errors?.length) await $37e96b9c44d16228$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        throw new (0, $i8byp.FetchError)('GraphQL query failed', {
            cause: err
        });
    }
};
class $37e96b9c44d16228$export$ba203f24e0131ba7 extends Error {
    constructor(message, { errors: errors, queryName: queryName }){
        super(message);
        this.errors = void 0;
        this.queryName = void 0;
        this.name = 'GraphQLError';
        this.errors = errors;
        this.queryName = queryName;
    }
}
const $37e96b9c44d16228$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $37e96b9c44d16228$export$ba203f24e0131ba7('GraphQL API error', {
        errors: errorsToThrow,
        queryName: $37e96b9c44d16228$var$extractQueryName(gqlQuery)
    });
};

});





//# sourceMappingURL=BrowseRovoAgentsModal.40a5f168.js.map
